// extracted by mini-css-extract-plugin
export default {"root_image_inner":"frameBannerForm_root_image_inner__LIEud"};